<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M25.5 5.5a1.5 1.5 0 00-3 0h3zm-1.5 37l-1.06 1.06a1.5 1.5 0 002.12 0L24 42.5zm13.56-11.44a1.5 1.5 0 00-2.12-2.12l2.12 2.12zm-25-2.12a1.5 1.5 0 00-2.12 2.12l2.12-2.12zM22.5 5.5v37h3v-37h-3zm2.56 38.06l12.5-12.5-2.12-2.12-12.5 12.5 2.12 2.12zm0-2.12l-12.5-12.5-2.12 2.12 12.5 12.5 2.12-2.12z"/></svg>